import Vue from 'vue'
import { isValidDate } from "@/helpers/helpers";

export default () => {
  Vue.filter('currency', function (value) {
    return value
  })

  Vue.filter('getCleanCategoryName', name => {
    if (typeof name !== 'string') return name
    return name.replace(/^\d+\.\s*/, '')
  })

  Vue.filter('getCleanEMBSHTML', description => {
    if (!description) return ""

    description = description.replace(/\|\|\|n\|\|\|/g, '\n')
    description = description.replace(/<table/g, '<div class="ebms-table"> <table')
    description = description.replace(/<\/table>/g, '</table></div>')

    return description
  })

  Vue.filter('getCleanEMBSString', description => {
    if (!description) return ""

    description = description.replace(/\|\|\|n\|\|\|/g, '\n')

    return description
  })

  Vue.filter('clearEBMSExtraSigns', text => {
    if (!text) return ""

    text = text.replace(/\|\|\|n\|\|\|/g, '')
    text = text.replace(/\r\n/g, "");

    return text
  })

  

  Vue.filter('formatDate', function (value) {
    if (isValidDate(value)) {

      try {
        const date = new Date(value);
        return new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        }).format(date);
      } catch (err) {
        console.log(err)
        return ''
      }
    }

    return '-'
  });

  Vue.filter('formatPhone', function (value) {
    if (!value) return '';

    const cleaned = value.replace(/[^\d+]/g, '');

    const matchPlus1 = cleaned.match(/^\+1(\d{10})$/);
    if (matchPlus1) {
      const number = matchPlus1[1];
      const area = number.slice(0, 3);
      const part1 = number.slice(3, 6);
      const part2 = number.slice(6, 8);
      const part3 = number.slice(8, 10);
      return `+1 (${area}) ${part1}-${part2}-${part3}`;
    }

    const match1 = cleaned.match(/^1(\d{10})$/);
    if (match1) {
      const number = match1[1];
      const area = number.slice(0, 3);
      const part1 = number.slice(3, 6);
      const part2 = number.slice(6, 8);
      const part3 = number.slice(8, 10);
      return `+1 (${area}) ${part1}-${part2}-${part3}`;
    }

    return value;
  });


  Vue.filter("removeExtension", function (filename) {
    if (!filename) return "";
    return filename.replace(/\.[^/.]+$/, "");
  });

}